import { z } from 'zod'
import { apiRequest } from '@/lib/api-client'

// Demo-Content-API (M8.1): kuratierte Beispiel-Dateien fuer den Onboarding-Seed
// sowie deren vollstaendige Entfernung. Spiegelt apps/backend/src/routes/demo.ts.

export const demoFileSchema = z.object({
  filename: z.string(),
  targetFolder: z.string(),
  content: z.string(),
})
export type DemoFile = z.infer<typeof demoFileSchema>

const demoContentResponseSchema = z.object({
  files: z.array(demoFileSchema),
})
export type DemoContentResponse = z.infer<typeof demoContentResponseSchema>

export const demoRemovalResultSchema = z.object({
  removed: z.array(z.string()),
  skipped: z.array(z.string()),
  errors: z.array(z.object({ path: z.string(), message: z.string() })),
})
export type DemoRemovalResult = z.infer<typeof demoRemovalResultSchema>

export function fetchDemoContent() {
  return apiRequest({ path: '/demo/content', schema: demoContentResponseSchema })
}

export function removeDemoContent() {
  return apiRequest({
    method: 'POST',
    path: '/demo/remove',
    schema: demoRemovalResultSchema,
  })
}
